module.exports = __webpack_public_path__ + "static/img/EIU-logo--horizontal.7b8a9fff.svg";